import type { Locale } from 'date-fns';
import enIN from 'date-fns/locale/en-IN';
import hi from 'date-fns/locale/hi';
import { useTranslation } from 'react-i18next';

export const dateFnsLocaleFor = (language: string | undefined): Locale => (language?.startsWith('hi') ? hi : enIN);

export const useDateFnsLocale = (): Locale => {
  const { i18n } = useTranslation();
  return dateFnsLocaleFor(i18n.resolvedLanguage ?? i18n.language);
};
